import React from 'react';
import styles from './FlagRow.module.scss';
import { Button } from 'components';
import Icon from 'assets/icons';

interface ButtonRowProps {
  name: string;
  desc: string;
  onClick: any;
}

export const ButtonRow: React.FC<ButtonRowProps> = ({ name, desc, onClick }) => {
  return (
    <div className={styles.Row}>
      <div>
        <div className={styles.FlagName}>{name}</div>
        <br />
        <div className={styles.FlagDesc}>{desc}</div>
      </div>
      <Button className={styles.FlagButton} onClick={onClick}>
        <Icon.ChevronThick />
      </Button>
    </div>
  );
};
